<template>
  <aside
    class="main-sidebar sidebar-dark-danger elevation-4"
    style="z-index: 10 !important"
    :style="[
      zIndexModal && { 'z-index': '0 !important' },
      zIndexTablaModal && { 'z-index': '0 !important' },
      !zIndexModal && !zIndexTablaModal && { 'z-index': '10 !important' }
    ]" 
    
  >

    <div class="brand-link" style="text-decoration: none !important">
      <div class="d-flex align-items-center">
        <img alt="UCCLOG" class="brand-image elevation-3" :src="Logo" />
        <span class="brand-text font-weight-light ml-3" style="text-decoration: none !important; font-size:23px">UCC</span>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="sidebar">
      <div
        class="user-panel mt-3 pb-3 mb-3 d-flex align-items-center"
        style="cursor: pointer"
        @click="direccionamiento()"
      >
        <!-- Avatar -->
        <div class="image" @click="direccionamiento()">
          
          <img v-if="avatarMiniatura" :src="avatarMiniatura" class="img-circle elevation-2" alt="User Image" />
          <img v-else src="/avatar_default.png" class="img-circle elevation-2" alt="User Image" />

        </div>

        <!-- Text -->
        <div class="info" @click="direccionamiento()">
          <a class="d-block" style="text-decoration: none" >
            <div>
              <div
                style="font-size: 14px; font-weight: bold"
                v-text="`${userContext.nombre} ${userContext.apellido}`"
              ></div>
              <div
                style="font-size: 11px"
                v-text="`${userContext.email}`"
              ></div>
              <span
                v-if="userContext.rol == 'Administrador'"
                class="badge rounded-pill bg-danger"
                style="color: white !important"
                v-text="
                  `${userContext.rol == 'Cliente' ? '' : userContext.rol}`
                "
              ></span>

              <span
                v-else
                class="badge rounded-pill bg-success"
                style="color: white !important"
                v-text="
                  `${userContext.rol == 'Cliente' ? '' : userContext.rol}`
                "
              ></span>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Sidebar Menu -->
    <nav>
      <ul
        class="nav nav-pills nav-sidebar flex-column"
        data-widget="treeview"
        role="menu"
        data-accordion="false"
      >
        <!-- Dashboard -->
        <!-- <li class="nav-item px-2 text" style="text-align: left">
          <router-link class="nav-link active" to="/">
            <i class="nav-icon fas fa-tachometer-alt"></i>
            <p>Dashboard</p>
          </router-link>
        </li> -->
        
        <SuperAdministrador v-if="showSuperAdmin" /> <!-- Superadministrador -->
        <Administracion v-if="showAdministracion" /> <!-- Administración -->
        <Lineas v-if="showLineas" /> <!-- Sub menu Lineas -->
        <Charter v-if="showCharter" />  <!-- sub menu charter -->
        <ServicioIntegral v-if="showServicioIntegral" /> <!-- sub menu Servicio Integral -->
        <SiFinanzas v-if="showSIFinanzas" /> <!-- sub menu SI Finanzas -->
        <!-- <Shipping v-if="showShippingInstruction" /> sub menu Shipping -->
        <Liquidations v-if="showLiquidaciones"/>

        <Tarifas />

      </ul>
    </nav>
  </aside>
</template>
<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:24
 */
// Import Scripts JS
import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/plugins/jquery/jquery.js";
import "admin-lte/dist/js/adminlte.js";

import { mapState } from "vuex";

// Images
import Logo from "../../assets/img/logos/logo.png";
import User from "../../assets/img/avatars/user.jpg";

// Secciones
import SuperAdministrador from "../../components/subMenus/SubSuperAdministrador";
import Administracion from "../../components/subMenus/SubAdministracion";
import Lineas from "../../components/subMenus/SubLineas";
import Charter from "../../components/subMenus/SubCharter";
import ServicioIntegral from "../../components/subMenus/SubServicioIntegral";
import SiFinanzas from "../../components/subMenus/SubSiFinanzas";
import Liquidations from "@/components/subMenus/SubLiquidations.vue";
import Tarifas from "@/components/subMenus/SubTarifas.vue";
// import Shipping from "../../components/subMenus/SubShipping";

export default {
  data() {
    return {
      Logo,
      User,
      userContext: {},
      hoverMenu: false,
      showLineas: false,
      showCharter: false,
      showServicioIntegral: false,
      showSIFinanzas: false,
      showAdministracion: false,
      showShippingInstruction: false,
      showSuperAdmin: false,
      showLiquidaciones: false,
      showServiciosLogisticos: false,
      URL : this.avatarMiniatura
    };
  },
  computed: {

    ...mapState(["usuarioActual", "zIndexModal","zIndexTablaModal","isAdmin", "avatarMiniatura"]),

    ...mapState("modulosLogin", [
      "isSuperAdministrador",
      "isAdministracion",
      "isLineas",
      "isCharter",
      "isServIntegral",
      "isFinanzas",
      "isShipping",
    ]),

  },
  components: {
    SuperAdministrador,
    Administracion,
    Lineas,
    Charter,
    ServicioIntegral,
    SiFinanzas,
    // Shipping,
    Liquidations,
    Tarifas
  },

  methods: {
    hoverMenuAux(estado) {
      if (estado) {
        this.hoverMenu = estado;
      } else {
        this.hoverMenu = estado;
      }
    },

    superUser(){
      this.showLineas = true;
      this.showCharter = true; // in development
      // this.showServicioIntegral = true; // in development
      // this.showSIFinanzas = true; // in development
      this.showAdministracion = true;
      this.showShippingInstruction = true;
      this.showSuperAdmin = true;
      this.showLiquidaciones =  true;
      this.showServiciosLogisticos =  true;
    },

    direccionamiento() {
      this.$router.push({ path: "/administracion/perfil_usuario"}).catch(()=>{});
    },
  },
  created(){

    this.userContext = JSON.parse(localStorage.getItem('user'));
    const userRoleStructure = JSON.parse(localStorage.getItem('roleStructure'));
    userRoleStructure.map(({idModule}) => {
      switch (idModule) {
        case 1: this.showLineas = true; break;
        case 2: this.showCharter = true; break; // in development
        // case 3: this.showServicioIntegral = true; break; // in development
        // case 4: this.showSIFinanzas = true; break; // in development
        case 5: this.showAdministracion = true; break;
        case 6: this.showShippingInstruction = true; break;
        case 7: this.showSuperAdmin = true; break;
        case 8: this.showLiquidaciones = true; break;
        case 9: this.showServiciosLogisticos = true; break;
        default: break;
      }
    });
    const userStructure = JSON.parse(localStorage.getItem('userStructure'));
    userStructure.map(({idModule}) => {
      switch (idModule) {
        case 1: this.showLineas = true; break;
        case 2: this.showCharter = true; break; // in development
        // case 3: this.showServicioIntegral = true; break; // in development
        // case 4: this.showSIFinanzas = true; break; // in development
        case 5: this.showAdministracion = true; break;
        case 6: this.showShippingInstruction = true; break;
        case 7: this.showSuperAdmin = true; break;
        case 8: this.showLiquidaciones =  true; break;
        case 9: this.showServiciosLogisticos = true; break;
        default: break;
      }
    });
  },

};
</script>

<style>
.text {
  font-size: 14px !important;
}

.badge {
  padding: 0.1em 0.4em !important;
  font-size: 0.65em !important;
  font-weight: 400 !important;
  line-height: 1.3;
}

.bg-success {
  background: #22770a !important;
}

</style>
